import apiClient from './client'
import type { User, UserCreatePayload, UserUpdatePayload } from '@/types'

const BASE = '/users'

export async function listUsers(): Promise<User[]> {
  const response = await apiClient.get<User[]>(`${BASE}/`)
  return response.data
}

export async function createUser(payload: UserCreatePayload): Promise<User> {
  const response = await apiClient.post<User>(`${BASE}/`, payload)
  return response.data
}

export async function updateUser(id: number, payload: UserUpdatePayload): Promise<User> {
  const response = await apiClient.put<User>(`${BASE}/${id}`, payload)
  return response.data
}

export async function deleteUser(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

export async function resetUserPassword(id: number, newPassword: string): Promise<User> {
  const response = await apiClient.post<User>(`${BASE}/${id}/reset-password`, {
    password: newPassword,
  })
  return response.data
}
